module.exports = __webpack_public_path__ + "static/media/customer_graphics_hlt_logo.b4ba4f65.svg";